import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';
import { IAddress } from '../../types/geo';
import { experimentToggle } from '../experimentToggle';

export interface IAddressProps {
  address: IAddress[];

  isRedesignExperimentActive?: boolean;
  isBooked?: boolean;
}

function createAddressString(address: IAddress[]): string {
  let result = '';

  address.forEach((addressItem, index) => {
    result += addressItem.title + (index !== address.length - 1 ? ', ' : '');
  });

  return result;
}

export function Address({ address, isRedesignExperimentActive = false, isBooked }: IAddressProps) {
  /**
   * @todo experimentToggle - временное решение, удалить после завершения эксперимента aud_mobile_bx585_saved_search_favorites_merge
   */
  return experimentToggle(
    isRedesignExperimentActive,
    BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
    <div>
      {address.map((addressItem, index) => {
        return (
          <span key={`key_${index}_${addressItem.fullUrl}`}>
            <UIText2 display="inline" color={isBooked ? 'text-secondary-default' : 'text-primary-default'}>
              {addressItem.title}
              {index !== address.length - 1 ? ', ' : ''}
            </UIText2>
          </span>
        );
      })}
    </div>,
    <UIText2 color={isBooked ? 'text-secondary-default' : 'text-primary-default'}>
      {createAddressString(address)}
    </UIText2>,
  );
}
